import { ELanguage } from '~/components/UiLanguage/UiLanguage.types'

export const LANGUAGES: Record<string, string> = {
  [ELanguage.Polish]: '/icons/languages/polish.svg',
  [ELanguage.English]: '/icons/languages/english.svg',
}
